import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { brandSecondary, destructive, header } from '../../../styles/colors';
import { truncateTextStyle } from '../../../styles/styles';

const {
	spacing: { sm },
	queries,
} = THEME;

const avatarSize = 40;

export const styleSheet = StyleSheet.create({
	avatar: {
		height: avatarSize,
		width: avatarSize,
	},
	avatarContainer: {
		alignSelf: 'flex-start',
		alignItems: 'center',
		display: 'flex',
		marginRight: 10,
	},
	container: {
		':hover': {
			'--texting-conversation-item-menu-trigger': '1',
			backgroundColor: '#f4f5f7',
			cursor: 'pointer',
		},
		alignItems: 'stretch',
		display: 'flex',
		padding: sm,
		position: 'relative',
		'--texting-conversation-item-menu-trigger': '0',
		':focus-within': {
			'--texting-conversation-item-menu-trigger': '1',
			backgroundColor: '#f4f5f7',
		},
	},
	contentWrapper: {
		[queries.lg]: {
			display: 'none',
		},
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		justifyContent: 'center',
		overflow: 'hidden',
		gap: 8,
	},
	conversationNamesContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: 4,
		width: '100%',
	},
	conversationNames: {
		...truncateTextStyle,
		fontSize: 14,
		padding: 0,
		margin: 0,
	},
	description: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: 4,
		overflow: 'hidden',
		width: '100%',
	},
	errorContainer: {
		alignItems: 'center',
		display: 'flex',
		minWidth: 20,
	},
	gray: {
		color: header,
		fontSize: 14,
	},
	lastMessage: {
		...truncateTextStyle,
	},
	menu: {
		minWidth: 148,
	},
	moreOptionsTrigger: {
		// @ts-ignore
		opacity: 'var(--texting-conversation-item-menu-trigger)',
	},
	selected: {
		background: 'rgba(211, 219, 222, 0.4)',
	},
	sinceLastMessage: {
		flexShrink: 0,
		fontSize: 12,
		color: header,
	},
	unread: {
		fontWeight: 700,
	},
	unreadDot: {
		background: brandSecondary,
		borderRadius: '50%',
		height: 8,
		left: 8,
		width: 8,
	},
	unsubscribed: {
		color: destructive,
		fontSize: 14,
	},
});
